import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  id: any
  clientes: any = []

  constructor() { }

  getAllClientes() {
    return gql`
      query getAllClientes {
          clientes(sort: "createdAt:DESC") {
            id
            estado
            nombreComercial
            cif
            customID
            contactoResponsable {
              nombre
            }
            createdAt
            contactoContratista {
              numero
            }
            centros{
              id
              estado
              documentos{
                estado
                tipo
              }
            }
          }
        }
    `;
  }

  getAllClientesGreen() {
    return gql`
      query getAllClientes {
          clientes(
            where: {
              estado: "verde"
            }) {
            id
            estado
            nombreComercial
            cif
            customID
            contactoResponsable {
              nombre
            }
            createdAt
            contactoContratista {
              numero
            }
            centros{
              id
              estado
              documentos{
                estado
                tipo
              }
            }
          }
        }
    `;
  }

  getAllClientesYellow() {
    return gql`
      query getAllClientes {
          clientes(
            where: {
              estado: "amarillo"
            }) {
            id
            estado
            nombreComercial
            cif
            customID
            contactoResponsable {
              nombre
            }
            createdAt
            contactoContratista {
              numero
            }
            centros{
              id
              estado
              documentos{
                estado
                tipo
              }
            }
          }
        }
    `;
  }

  getAllClientesRed() {
    return gql`
      query getAllClientes {
          clientes(
            where: {
              estado: "rojo"
            }) {
            id
            estado
            nombreComercial
            cif
            customID
            contactoResponsable {
              nombre
            }
            createdAt
            contactoContratista {
              numero
            }
            centros{
              id
              estado
              documentos{
                estado
                tipo
              }
            }
          }
        }
    `;
  }


  getClientesCif() {
    return gql`
      query getClientesCif {
        clientes {
          cif
          contactoResponsable {
            nombre
            mail
          }
        }
      } 
    `;
  }

  getAllClientesDougtnout() {
    return gql`
    query getAllClientes {
      clientes(sort: "createdAt:DESC") {
        estado
        id
        centros {
          estado
          id
          documentos {
            tipo
            estado
          }
          transportistas {
            id
            estado
            documentos {
              tipo
              estado
            }
          }
          gestors {
            id
            estado
            documentos {
              tipo
              estado
            }
          }
        }
      }
    }
    `;
  }

  getClienteById() {
    return gql`
      query getClienteById($id: ID!) {
          cliente(id: $id) {
            id
            motivoAlta
            razonSocial
            firstTime
            cif
            xtensaBasica
            nombreComercial
            logo
            resPeligrosos
            customID
            documentos_adicionals{
              id
              nombreArchivo
              periocidad
              firstTime
              tipo
              estado
              numArchivo
              contratista{
                id
              }
            }
            licencias{
              id
              IDLicencia
              contratista {
                id
              }
            }
            instalaciones{
              id
              nombre
            }
            transportistas{
              id
            }
            gestores{
              id
            }
            domicilio{
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
              numero
              letra
              pta
              localidad
            }
            actividad
            infoContactoProveedores
            contactoResponsable{
              nombre
              cargo
              mail
            }
            contacto{
              nombre
              cargo
              mail
            }
            zonas{
              nombre
              id
            }
            agrupacions{
              nombre
            }
            contratistas{
              nombreComercial
              id
              contactoResponsable{
                mail
              }
              instalacions{
                id
                nombre
              }
            }
            centros{
              id
              transportistas{
                id
              }
              gestors{
                id
              }
              contratista{
                id
                nombreComercial
                contactoResponsable{
                  mail
                }
              }
            }
          }
        }
    `;
  }



  addCliente() {
    return gql`
      mutation createCliente($input: createClienteInput!) {
      createCliente(input: $input) {
        cliente {
          id
          nombreComercial
          xtensaBasica
          contactoContratista {
            mail
            numero
            cif
          }
        }
      }
    }
    `;
  }

  updateCliente() {
    return gql`
      mutation updateCliente($input: updateClienteInput!) {
        updateCliente(input: $input) {
          cliente {
            id
            instalaciones {
              nombre
            }
            contratistas {
              id
            }
          }
        }
      }
    `;
  }



  deleteCliente() {
    return gql`
      mutation deleteCliente($input: deleteClienteInput!) {
        deleteCliente(input: $input) {
          cliente {
            id
          }
        }
      }
    `;
  }

  getInstalacionesByCliente() {
    return gql`
      query getInstalacionesByCliente($id: ID!){
        cliente(id: $id){
          xtensaBasica
          instalaciones{
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            contratistas{
              nombreComercial
              estado
            }
            centro{
              estado
              id
              gestors{
                estado
                documentos{
                  estado
                  tipo
                }
              }
              transportistas{
                estado
                documentos{
                  estado
                  tipo
                }
              }
              documentos{
                estado
                tipo
              }
            }
          }
        }
      }
    `;
  }

  getInstalacionesGreenCliente() {
    return gql`
      query getInstalacionesByCliente($id: ID!){
        cliente(id: $id){
          xtensaBasica
          instalaciones(
            where:{
              estado:"verde"
            }
          ){
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            contratistas{
              nombreComercial
              estado
            }
            centro{
              estado
              id
              gestors{
                estado
              }
              transportistas{
                estado
              }
              documentos{
                estado
                tipo
              }
            }
          }
        }
      }
    `;
  }

  getInstalacionesYellowCliente() {
    return gql`
      query getInstalacionesByCliente($id: ID!){
        cliente(id: $id){
          xtensaBasica
          instalaciones(
            where:{
              estado:"amarillo"
            }
          ){
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            contratistas{
              nombreComercial
              estado
            }
            centro{
              estado
              id
              gestors{
                estado
              }
              transportistas{
                estado
              }
              documentos{
                estado
                tipo
              }
            }
          }
        }
      }
    `;
  }

  getInstalacionesRedCliente() {
    return gql`
      query getInstalacionesByCliente($id: ID!){
        cliente(id: $id){
          xtensaBasica
          instalaciones(
            where:{
              estado:"rojo"
            }
          ){
            id
            nombre
            direccion {
              tipoVia
              nombre
              numero
              ccaa
            }
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            contratistas{
              nombreComercial
              estado
            }
            centro{
              estado
              id
              gestors{
                estado
              }
              transportistas{
                estado
              }
              documentos{
                estado
                tipo
              }
            }
          }
        }
      }
    `;
  }

  getContratistasByCliente() {
    return gql`
      query getContratistasByCliente($id: ID!){
        cliente(id: $id){
          contratistas{
            id
            nombreComercial
            estado
            contactoResponsable {
              mail
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
              clientes{
                id
                estado
                centros{
                  estado
                }
              }
            }
            documentos{
              estado
            }
          }
        }
      }
    `;
  }

  getContratistasGreenCliente() {
    return gql`
      query getContratistasByCliente($id: ID!){
        cliente(id: $id){
          contratistas(
            where:{
              estado:"verde"
            }
          ){
            id
            nombreComercial
            estado
            contactoResponsable {
              mail
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
              clientes{
                id
                estado
                centros{
                  estado
                }
              }
            }
            documentos{
              estado
            }
          }
        }
      }
    `;
  }

  getContratistasYellowCliente() {
    return gql`
      query getContratistasByCliente($id: ID!){
        cliente(id: $id){
          contratistas(
            where:{
              estado:"amarillo"
            }
          ){
            id
            nombreComercial
            estado
            contactoResponsable {
              mail
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
              clientes{
                id
                estado
                centros{
                  estado
                }
              }
            }
            documentos{
              estado
            }
          }
        }
      }
    `;
  }

  getContratistasRedCliente() {
    return gql`
      query getContratistasByCliente($id: ID!){
        cliente(id: $id){
          contratistas(
            where:{
              estado:"rojo"
            }
          ){
            id
            nombreComercial
            estado
            contactoResponsable {
              mail
              nombre
            }
            centros{
              id
              estado
              documentos{
                tipo
                estado
              }
              clientes{
                id
                estado
                centros{
                  estado
                }
              }
            }
            documentos{
              estado
            }
          }
        }
      }
    `;
  }

  getContratistasByClienteDoughnout() {
    return gql`
      query getContratistasByCliente($id: ID!){
        cliente(id: $id){
          contratistas{
            id
            estado
            centros{
              id
              estado
              documentos{
                estado
                tipo
              }
              gestors {
                id
                documentos{
                  estado
                  tipo
                }
              }
              transportistas {
                id
                documentos{
                  estado
                  tipo
                }
              }
            clientes{
                id
                estado
                centros{
                  estado
                }
              }
            }
            documentos{
              estado
              tipo
            }
          }
        }
      }
    `;
  }

  getCentrosByCliente() {
    return gql`
      query getCentrosByCliente($id: ID!){
        cliente(id: $id){
          centros{
            id
            IdCentro
            estado
            contratista {
              nombreComercial
            }
            zona {
              nombre
            }
            nombre
            contactoResponsable {
              mail
              nombre
            }
            contacto{
              mail
            }
            direccion{
              tipoVia
              nombre
              numero
              provincia
              ccaa
            }
            gestors{
              id
              estado
              cif
              nombre
              mailContacto
              centros{
                id
                nombre
              }
              domicilio{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }

            }
            transportistas{
              id
              estado
              cif
              nombre
              mailContacto
              
              direccion{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }
              centros{
                id
                nombre
              }
            }
            documentos{
              estado 
              tipo
            }
          }
        }
      }
    `;
  }

  getCentrosGreenCliente() {
    return gql`
      query getCentrosByCliente($id: ID!){
        cliente(id: $id){
          centros(
            where: {
              estado: "verde"
            }
          ){
            id
            estado
            contratista {
              nombreComercial
            }
            zona {
              nombre
            }
            nombre
            contactoResponsable {
              mail
              nombre
            }
            contacto{
              mail
            }
            direccion{
              tipoVia
              nombre
              numero
              provincia
              ccaa
            }
            gestors{
              id
              estado
              cif
              nombre
              mailContacto
              centros{
                id
                nombre
              }
              domicilio{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }

            }
            transportistas{
              id
              estado
              cif
              nombre
              mailContacto
              
              direccion{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }
              centros{
                id
                nombre
              }
            }
            documentos{
              estado 
              tipo
            }
          }
        }
      }
    `;
  }

  getCentrosYellowCliente() {
    return gql`
      query getCentrosByCliente($id: ID!){
        cliente(id: $id){
          centros(
            where: {
              estado: "amarillo"
            }
          ){
            id
            estado
            contratista {
              nombreComercial
            }
            zona {
              nombre
            }
            nombre
            contactoResponsable {
              mail
              nombre
            }
            contacto{
              mail
            }
            direccion{
              tipoVia
              nombre
              numero
              provincia
              ccaa
            }
            gestors{
              id
              estado
              cif
              nombre
              mailContacto
              centros{
                id
                nombre
              }
              domicilio{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }

            }
            transportistas{
              id
              estado
              cif
              nombre
              mailContacto
              
              direccion{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }
              centros{
                id
                nombre
              }
            }
            documentos{
              estado 
              tipo
            }
          }
        }
      }
    `;
  }

  getCentrosRedCliente() {
    return gql`
      query getCentrosByCliente($id: ID!){
        cliente(id: $id){
          centros(
            where: {
              estado: "rojo"
            }
          ){
            id
            estado
            contratista {
              nombreComercial
            }
            zona {
              nombre
            }
            nombre
            contactoResponsable {
              mail
              nombre
            }
            contacto{
              mail
            }
            direccion{
              tipoVia
              nombre
              numero
              provincia
              ccaa
            }
            gestors{
              id
              estado
              cif
              nombre
              mailContacto
              centros{
                id
                nombre
              }
              domicilio{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }

            }
            transportistas{
              id
              estado
              cif
              nombre
              mailContacto
              
              direccion{
                ccaa
                provincia
              }
              documentos{
                id
                tipo
                estado
              }
              centros{
                id
                nombre
              }
            }
            documentos{
              estado 
              tipo
            }
          }
        }
      }
    `;
  }

  getCentrosByClienteDoughnout() {
    return gql`
      query getCentrosByCliente($id: ID!){
        cliente(id: $id){
          centros{
            id
            estado
            gestors{
              id
              estado
              documentos{
                estado 
                tipo
              }
            }
            transportistas{
              id
              estado
              documentos{
                estado 
                tipo
              }
            }
            documentos{
              estado 
              tipo
            }
          }
        }
      }
    `;
  }

  getGestoresByCliente() {
    return gql`
      query getGestoresByCliente($id: ID!){
        cliente(id: $id){
          gestores {
            id
            nombre
            cif
            nombreContacto
            estado
            domicilio{
              provincia
              ccaa
            }
            documentos{
              tipo
              estado
            }
          }
        }
      }
    `;
  }



  getGestoresByClienteDoughnout() {
    return gql`
      query getGestoresByCliente($id: ID!){
        cliente(id: $id){
          gestores {
            id
            estado
            documentos{
              tipo
              estado
            }
          }
        }
      }
    `;
  }

  getZonasByCliente() {
    return gql`
      query getZonasByCliente($id: ID!){
        cliente(id: $id){
          zonas {
            id
            nombre
           
            
          }
        }
      }
    `;
  }

  getTransportistasByCliente() {
    return gql`
      query getTransportistasByCliente($id: ID!){
        cliente(id: $id){
          transportistas {
            id
            nombre
            cif
            codigo
            nima
            nombreContacto
            estado
            direccion{
              provincia
              ccaa
            }
            documentos{
              estado
              tipo
            }
          }
        }
      }
    `;
  }


  getTransportistasByClienteDoughnout() {
    return gql`
      query getTransportistasByCliente($id: ID!){
        cliente(id: $id){
          transportistas {
            id
            estado
            documentos{
              estado
              
            }
          }
        }
      }
    `;
  }

  getAllClientesName() {
    return gql`
      query getAllClientes {
          clientes(sort: "nombreComercial:ASC") {
            id
            nombreComercial
          }
        }
    `;
  }

  setIdCliente(id: any) {
    this.id = id;
  }

  getIdCliente() {
    let temp = this.id;
    this.clearIdCliente();
    return temp;
  }

  clearIdCliente() {
    this.id = undefined;
  }

  setClientes(clientes: any) {
    this.clientes = clientes;
  }

  getClientes() {
    let temp = this.clientes;
    this.clearClientes();
    return temp;
  }

  clearClientes() {
    this.clientes = undefined;
  }

}
